import React, { useContext, useState, useEffect, useRef } from "react";
import PageHeader from "../Common/PageHeader";
import { Container, Box, TextField, Button, Typography } from "@mui/material";
import Autocomplete, { autocompleteClasses } from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { ArrowForwardIosOutlined } from "@mui/icons-material";
import { MyContext } from "../../globalContext";
import PropTypes from "prop-types";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SearchViewResults from "../NetworkSelection/SearchViewResults";
import { getConfig } from "../../loadconfig";
import {
  fetchAutoSuggest,
  fetchContentFromAzureBlobStorage,
  getProviderSearchImage,
} from "../../data/Contentapi";
import Constants from "../../utils/Constants";
import Popper from "@mui/material/Popper";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import ErrorFallBackComponent from "../../utils/ErrorFallBackComponent";

import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import DOMPurify from "dompurify";
import trackClick from "../../data/ClickTracking.js";

import AddressLookup from "../Common/AddressLookup";
import { commonPublishEvent } from "../../utils/PublishEventMethod";

const theme = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            color: "#333", // Change this to your desired color
            opacity: 1, // Optional: to ensure the color is fully applied
            fontSize: "16px !important",
            fontFamily:
              "Ubuntu, Arial, Helvetica, Verdana, sans-serif !important",
          },
          "& .Mui-focused .MuiInputBase-input::placeholder": {
            color: "green !important", // Placeholder color when focused
            fontSize: "16px !important",
            fontFamily:
              "Ubuntu, Arial, Helvetica, Verdana, sans-serif !important",
          },
        },
      },
    },
  },
});

const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: "border-box",
    border: "2px solid #007839",
    "& ul": {
      padding: 0,
      margin: 0,
    },
    "& .MuiAutocomplete-option:hover": {
      backgroundColor: "#009a49",
      "& .hovered-white": {
        color: "white !important",
      },
    },
  },
});

const SearchView = ({ selSiteprop }) => {
  const config = getConfig();
  const location = useLocation();
  const { t } = useTranslation();
  const {
    languageData,
    selNetworkg,
    selSiteg,
    address,
    setAddressData,
    setShowSearchData,
    setShowSearchResultData,
    showSearchResult,
    setSearchCriteriaData,
    searchCriteria,
    setSearchPageNumberData,
    setSearchFilterData,
    jwtToken,
    getSessionIdData,
    redirectGenericSite
  } = useContext(MyContext);
  const mycontext = useContext(MyContext);

  const [textSearchValue, setTextSearchValue] = useState("");
  const [searchType, setSearchType] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [autosuggestFull, setAutosuggestFull] = useState([]);
  const [autosuggest, setAutosuggest] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [hasAboveText, setHasAboveText] = useState("");
  const [hasBelowText, setHasBelowText] = useState("");
  const [clientImage, setClientImage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageZip, setErrorMessageZip] = useState("");
  const [error, setError] = useState(false);
  const [errorZip, setErrorZip] = useState(false);
  const [searchDisplayStringVal, setSearchDisplayStringVal] = useState("");
  const [searchClientSpecificUrl, setSearchClientSpecificUrl] = useState("");
  const [metaData, setMetaData] = useState([]);
  const [isAutoSelected, setIsAutoSelected] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (address?.["error"] === true) {
      setErrorZip(true);
      setErrorMessageZip(t(`ziperror`));
      let newAdd = { ...address };
      newAdd["error"] = false;
      setAddressData(newAdd);
    }
  }, [address]);

  const getNetworkImage = async (clientsuffix) => {
    const imageData = await getProviderSearchImage(clientsuffix);
    if (imageData?.contentType && imageData?.imageString) {
      setClientImage(
        `data:${imageData.contentType};base64,${imageData.imageString}`
      );
    }
  };

  const getTopText = async () => {
    const hasAboveTextFg = selNetworkg[0].hasAboveText;
    const isValidFlag = hasAboveTextFg === "Y";

    if (isValidFlag) {
      const contVariable = selSiteg?.siteUrlSuffix
        ? selSiteg.siteUrlSuffix.toUpperCase()
        : selNetworkg[0].siteId;

      try {
        const content = await fetchContentFromAzureBlobStorage(
          languageData.toLowerCase(),
          "Customized Text",
          contVariable + Constants.ABOVE_TEXT
        );
        setHasAboveText(content.contentData);
      } catch (e) {
        console.log(e.message);
      }
    }
  };

  const getBelowText = async () => {
    const hasBelowTextFg = selNetworkg[0].hasBelowText;
    const isValidFlag = hasBelowTextFg === "Y";

    if (isValidFlag) {
      const contVariable = selSiteg?.siteUrlSuffix
        ? selSiteg.siteUrlSuffix.toUpperCase()
        : selNetworkg[0].siteId;

      try {
        const content = await fetchContentFromAzureBlobStorage(
          languageData.toLowerCase(),
          "Customized Text",
          contVariable + Constants.BELOW_TEXT
        );
        setHasBelowText(content.contentData);
      } catch (e) {
        console.log(e.message);
      }
    }
  };

  const filterAutosuggestByLanguageAndCategory = (autosuggestList) => {
    return autosuggestList.filter(
      (item) =>
        item.locale.toLowerCase() === languageData.toLowerCase() &&
        item.category.toLowerCase().includes("popular")
    );
  };

  const determineIncludeList = () => {
    const providerTypeList = selNetworkg[0]?.providerTypeList || [];
    if (providerTypeList.includes("P") && providerTypeList.includes("F")) {
      return ["facility", "specialty", "centro", "especialidad"];
    } else if (providerTypeList.includes("P")) {
      return ["specialty", "especialidad"];
    } else if (providerTypeList.includes("F")) {
      return ["facility", "centro"];
    }
    return ["facility", "specialty", "centro", "especialidad"];
  };

  const applyIncludeListFilter = (data, includeList) => {
    return data.filter((item) =>
      includeList.some((substring) =>
        item.category.toLowerCase().includes(substring)
      )
    );
  };

  const filterByFacilityTypeCodes = (filteredData) => {
    const facilityTypeCodes =
      selNetworkg[0].facilityTypeCodeList.map((item) =>
        item.facilityTypeCode.toLowerCase()
      ) || [];
    const includeCategoryList = ["specialty", "especialidad"];
    return filteredData.filter(
      (item) =>
        facilityTypeCodes.some((code) =>
          item.value.toLowerCase().includes(`${code}_`)
        ) ||
        includeCategoryList.some((category) =>
          item.category.toLowerCase().includes(category)
        )
    );
  };

  const fetchAndSetAutosuggest = async () => {
    try {
      const data = await fetchAutoSuggest(config.AUTOSUGGEST_URL, mycontext);
      setMetaData(data.meta);

      let includeList = determineIncludeList();
      let filteredAutosuggestAll = applyIncludeListFilter(
        data.autosuggest,
        includeList
      );

      if (selNetworkg[0]?.facilityTypeCodeList?.length > 0) {
        filteredAutosuggestAll = filterByFacilityTypeCodes(
          filteredAutosuggestAll
        );
      }

      setAutosuggestFull(filteredAutosuggestAll);
      setAutosuggest(
        filterAutosuggestByLanguageAndCategory(filteredAutosuggestAll)
      );
    } catch (e) {
      console.error(e.message);
    }
  };

  const filterAutosuggestOptions = (autosuggestList, filterFn) => {
    return autosuggestList.filter(
      (item) =>
        item.locale.toLowerCase() === languageData.toLowerCase() &&
        filterFn(item)
    );
  };

  const getFilterFn = () => {
    if (inputValue === "") {
      return (item) => item.category.toLowerCase().includes("popular");
    } else {
      return (item) =>
        item.label.toLowerCase().includes(inputValue.toLowerCase()) ||
        item.category.toLowerCase().includes(inputValue.toLowerCase());
    }
  };

  const fetchAutosuggestOptions = async () => {
    const filterFn = getFilterFn();
    const filteredAutosuggest = filterAutosuggestOptions(
      autosuggestFull,
      filterFn
    );
    setAutosuggest(filteredAutosuggest);
  };

  const isSearchValueValid = (searchVal) => {
    const regex = /^[^<>:?=]*$/;
    if (!searchVal) {
      setError(true);
      setErrorMessage(t(`searcherror`));
      return false;
    }
    if (searchVal.length < 4) {
      setError(true);
      setErrorMessage(t(`searcherrormin`));
      return false;
    }
    if (!regex.test(searchVal)) {
      setError(true);
      setErrorMessage("Special character is not allowed");
      return false;
    }
    return true;
  };

  const isAddressValid = () => {
    if (
      !address ||
      !Object.keys(address).length ||
      (!address.city && !address.zipCode && !address.state)
    ) {
      setErrorZip(true);
      setErrorMessageZip(t(`ziperror`));
      return false;
    }
    setErrorZip(false);
    setErrorMessageZip("");
    return true;
  };

  const setNetworkCriteria = () => {
    if (!selNetworkg || selNetworkg.length === 0) return;

    const allProductCodes = selNetworkg.flatMap(item => item.productCodeList);
    const uniqueProductCodes = [...new Set(allProductCodes)];

    const network = selNetworkg[0];
    searchCriteria["productCodeList"] =
    uniqueProductCodes || searchCriteria["productCodeList"];
    searchCriteria["displayName"] =
      network.displayName || searchCriteria["displayName"];
    searchCriteria["providerTypeList"] =
      network.providerTypeList || searchCriteria["providerTypeList"];
    searchCriteria["applyRestrictions"] = network.applyRestrictions === "Y";
    searchCriteria["applySuppressions"] = network.applySuppressions === "Y";
    searchCriteria["marketIdentifier"] =
      network.codeGroupList || searchCriteria["marketIdentifier"];
    searchCriteria["siteId"] = network.siteId || searchCriteria["siteId"];
    searchCriteria["suppressSpecialtyList"] =
      network.suppressproviderbyspecialtylist ||
      searchCriteria["suppressSpecialtyList"];
    searchCriteria["suppressNameList"] =
      network.suppressproviderbynamelist || searchCriteria["suppressNameList"];
    searchCriteria["clientAccountNumberList"] =
      network.clientAccountNumberList ||
      searchCriteria["clientAccountNumberList"];
      searchCriteria["codeGroupList"] =
      network.codeGroupList ||
      searchCriteria["codeGroupList"];
    searchCriteria["selectedNetwork"] =
      network.networkName || searchCriteria["selectedNetwork"];
  };

  const setSiteCriteria = () => {
    if (selSiteprop?.siteName) {
      searchCriteria["siteName"] = selSiteprop.siteName;
    }
  };

  const determineFacilityTypeName = (specialtyName) => {
    let TBD_facilityTypeName = searchType;
    const match = autosuggest.find(
      (item) =>
        item.locale.toLowerCase() === languageData.toLowerCase() &&
        item.label.toLowerCase() === specialtyName.toLowerCase()
    );

    if (match) {
      specialtyName = match.value;
      if (languageData.toLowerCase() === "es") {
        const enData = autosuggestFull.find(
          (item) =>
            item.value.toLowerCase() === specialtyName.toLowerCase() &&
            item.locale.toLowerCase() === "en"
        );
        TBD_facilityTypeName = enData ? enData.category : match.category;
      } else {
        TBD_facilityTypeName = match.category;
      }
    }
    return { TBD_facilityTypeName, specialtyName };
  };

  const filterSpecialtyNameByCode = (specialtyName, TBD_facilityTypeName) => {
    const includeCategoryList = ["specialty", "especialidad"];
    let facilityTypeCodesList = [];
    const containsCategory = includeCategoryList.some((category) =>
      TBD_facilityTypeName.toLowerCase().includes(category.toLowerCase())
    );

    if (
      !containsCategory &&
      selNetworkg[0]?.facilityTypeCodeList?.length > 0 &&
      TBD_facilityTypeName !== ""
    ) {
      const selectedCodes = specialtyName.split(",");
      const facilityTypeCodes = selNetworkg[0].facilityTypeCodeList.map(
        (item) => item.facilityTypeCode.toLowerCase()
      );

      specialtyName = selectedCodes
        .filter((item) =>
          facilityTypeCodes.some((code) =>
            item.toLowerCase().includes(`${code}_`)
          )
        )
        .join(",");
    } else if (
      selNetworkg[0]?.facilityTypeCodeList?.length > 0 &&
      TBD_facilityTypeName == ""
    ) {
      facilityTypeCodesList = selNetworkg[0]?.facilityTypeCodeList.map(
        (item) => item.facilityTypeCode
      );
    }

    return { specialtyName, facilityTypeCodesList };
  };

  const publishSearchEvent = async () => {
    const eventData = {
      Locale: languageData,
      "ReCaptcha version": "V3",
      "Zip Code": address.zipCode,
      "Site ID": searchCriteria.siteId,
      "Product Code": searchCriteria.productCodeList,
      "Provider Type List": searchCriteria.providerTypeList,
      "Search String": searchDisplayStringVal,
      "Code Group List": searchCriteria.codeGroupList,
      "Client Account Number List": searchCriteria.clientAccountNumberList,
    };

    await commonPublishEvent(
      "Provider Search",
      eventData,
      jwtToken,
      getSessionIdData()
    );

    trackClick(
      "Provider Search",
      "Search",
      searchDisplayStringVal,
      languageData
    );
  };

  const handleSearchResults = () => {
    const searchVal = textSearchValue || inputValue;
    const searchDisplayValue = searchDisplayStringVal || inputValue;
    const distanceVal = 20;
    let specialtyName = searchVal;
    let TBD_facilityTypeName = searchType;

    if (!isSearchValueValid(searchVal) || !isAddressValid()) return;

    let facilityTypeCodesList = [];
    if(!(isAutoSelected && languageData === "en")){
    ({ TBD_facilityTypeName, specialtyName } =
      determineFacilityTypeName(specialtyName));
    }
    ({ specialtyName, facilityTypeCodesList } = filterSpecialtyNameByCode(
      specialtyName,
      TBD_facilityTypeName
    ));

    setNetworkCriteria();
    setSiteCriteria();

    setSearchCriteriaData({
      ...searchCriteria,
      ...address,
      searchValue: specialtyName,
      searchType: TBD_facilityTypeName,
      facilityTypeCode: facilityTypeCodesList,
      distance: distanceVal,
      searchDisplayString: searchDisplayValue,
      viewLanguage: languageData,
    });

    setSearchFilterData({});
    setShowSearchResultData(true);
    setSearchPageNumberData(1);
    publishSearchEvent();
  };

  // Handler for autocomplete input change
  const handleAutocompleteInputChange = (event, val) => {
    setTextSearchValue("");
    setInputValue("");

    if (val === null || val === undefined || val === "") {
      setTextSearchValue("");
      setSearchType("");

      const filteredAutosuggest = autosuggestFull.filter(
        (item) =>
          item.locale.toLowerCase() === languageData.toLowerCase() &&
          item.category.toLowerCase().includes("popular")
      );
      setAutosuggest(filteredAutosuggest);

      return;
    }
    setIsAutoSelected(true);
    let searchInputValue = val.value === "" ? event.target.value : val.value;
    setTextSearchValue(searchInputValue);
    setShowSearchResultData(false);
    setSearchPageNumberData(1);

    let displayValue = val.value === "" ? event.target.value : val.label;
    setSearchDisplayStringVal(displayValue);

    if (languageData === "es") {
      const enData = autosuggestFull.filter(
        (item) =>
          item.value.toLowerCase() === val.value.toLowerCase() &&
          item.locale.toLowerCase() === "en"
      );
      if (enData.length > 0) {
        setSearchType(enData[0].category);
      }
    } else {
      setSearchType(val.category);
    }

    setShowSearchResultData(false);
    setSearchPageNumberData(1);
  };

  // Function to highlight text
  const highlightText = (text, highlight) => {
    setError(false);
    setErrorMessage("");
    setShowSearchResultData(false);
    setSearchPageNumberData(1);

    const parts = text
      .split(new RegExp(`(${highlight})`, "gi"))
      .map((part, index) => {
        const isHighlighted = part.toLowerCase() === highlight.toLowerCase();
        return isHighlighted ? (
          <span
            key={index}
            className="hovered-white"
            style={{ color: "green", fontWeight: "bold" }}
          >
            {part.trim()}
          </span>
        ) : (
          part
        );
      });

    return <div>{parts}</div>;
  };

  // Handler for checkbox change
  const handleChange = (event) => {
    setIsChecked(event.target.checked);
    localStorage.removeItem("selNetworkg");
    localStorage.removeItem("selSiteg");
    localStorage.removeItem("searchClientSpecificUrl");
    localStorage.removeItem("selSiteprop");

    if (event.target.checked) {
      const localStorageItems = {
        selNetworkg: JSON.stringify(selNetworkg),
        selSiteg: JSON.stringify(selSiteg),
        searchClientSpecificUrl: searchClientSpecificUrl,
        selSiteprop: JSON.stringify(selSiteprop),
      };

      Object.keys(localStorageItems).forEach((key) => {
        localStorage.setItem(key, localStorageItems[key]);
      });
    }
  };

  const handleAutocompleteClose = () => {
    setTextSearchValue("");
    setInputValue("");
    setSearchDisplayStringVal("");
  };

  // Handler for text search change
  const handleTextSearchChange = (event) => {
    setIsAutoSelected(false);
    setInputValue(event.target.value);
    setTextSearchValue(event.target.value);
    setSearchDisplayStringVal(event.target.value);
    setSearchType("");
    setError(false);
    setErrorMessage("");
    setShowSearchResultData(false);
    setSearchPageNumberData(1);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      const value = event.target.value;

      setInputValue(value);
      setTextSearchValue(value);
      setSearchDisplayStringVal(value);

      setTimeout(handleSearchResults, 1000);
    }
  };

  useEffect(() => {
    getTopText();
    getBelowText();
    setSearchCriteriaData({ ...searchCriteria, viewLanguage: languageData });

    if (inputRef.current) {
      inputRef.current.value = "";
      const event = new Event("input", { bubbles: true });
      inputRef.current.dispatchEvent(event);
    }
  }, [languageData]);

  // Function to handle link click changes
  const changeLinkClick = () => {
    const hasSelectedNetworkOrSite =
      localStorage.getItem("selNetworkg") !== null ||
      localStorage.getItem("selSiteg") !== null;

    if (hasSelectedNetworkOrSite) {
      localStorage.removeItem("selNetworkg");
      localStorage.removeItem("selSiteg");
      localStorage.removeItem("searchClientSpecificUrl");
    }

    setShowSearchData(false);
    setShowSearchResultData(false);
    setSearchPageNumberData(1);
  };

  useEffect(() => {
    getTopText();
    getBelowText();
    setSearchClientSpecificUrl(location.search);

    if (selSiteprop && selSiteprop !== "undefined" && selSiteprop !== "null") {
      getNetworkImage(selSiteprop.siteUrlSuffix);
    }
  }, []);

  useEffect(() => {
    if (autosuggestFull?.length > 0) {
      setAutosuggest(filterAutosuggestByLanguageAndCategory(autosuggestFull));
    } else if (jwtToken && jwtToken !== "") {
      fetchAndSetAutosuggest();
    }
  }, [languageData]);

  useEffect(() => {
    fetchAutosuggestOptions();
  }, [inputValue, textSearchValue]);

  const sanitizedhasAboveText = DOMPurify.sanitize(hasAboveText);
  const sanitizedNetworkName = DOMPurify.sanitize(selNetworkg[0].networkName);
  const sanitizedhasBelowText = DOMPurify.sanitize(hasBelowText);

  const selSitegData = () =>
    selSiteg ? (
      <>
        {t("searchinnetwork")}
        <h2 style={{ color: "#007839" }}>{selNetworkg.map((network, index) => (
                <div key={index}>
                    {network.networkCode}
                </div>
            ))}</h2>
        {/* <h3>{selSiteg.siteName}</h3>  */}
      </>
    ) : (
      <>
        <div className="font16">{t("searchinnetwork")}</div>
        <h1 className="mt-5px" style={{ fontSize: "18px" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: selNetworkg && sanitizedNetworkName,
            }}
          />
        </h1>
      </>
    );

  const useOptions = () =>
    inputValue?.length > 3 || inputValue?.length === 0 ? autosuggest : [];

  return (
    <Container sx={{ width: "100%", marginY: "2%" }} fixed>
      <Box sx={{ width: "100%" }}>
        <Box>
          {" "}
          <PageHeader displayText="search" />{" "}
        </Box>

        {metaData.statusCode === "F" ? (
          <ErrorFallBackComponent />
        ) : (
          <Container sx={{ width: "100%", marginY: "2%" }} fixed>
            <Box>
              <Box className="aboveText">
                <div
                  dangerouslySetInnerHTML={{ __html: sanitizedhasAboveText }}
                ></div>
              </Box>

              <Box className="search-box" ml={7}>
                <Box className="search-text-width ">
                  <Typography
                    variant="body2"
                    align="left"
                    data-testid="search-statement-name"
                  >
                    <div className="respOnly pt-20p">
                      {selSiteprop?.siteName && selSiteprop?.redirect  != "Y"  && (
                        <Box className="customizedSearch">
                          <Box sx={{ mb: 3 }}>{t("customizedfor")}</Box>
                          <Box sx={{ mb: 3 }}>
                            <img
                              src={clientImage}
                              alt={selSiteprop.siteName}
                              className="mt-20px"
                            />
                          </Box>
                        </Box>
                      )}
                    </div>
                    {selSitegData()}
                  </Typography>
                </Box>

                <Box>
                  <div className="SearchResponsive">
                    <div>
                      <b>{t("enterCriteria")}:</b>
                    </div>
                    <ul className="square-green-list">
                      {[
                        "providerName",
                        "speciality",
                        "facilityType",
                        "npi#",
                        "license#",
                      ].map((item, index) => (
                        <li key={index}>{t(item)}</li>
                      ))}
                    </ul>
                  </div>
                  <Box className="aboveTextresp">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitizedhasAboveText,
                      }}
                    ></div>
                  </Box>

                  <div
                    className="textfield-container"
                    style={{ position: "relative" }}
                  >
                    <Autocomplete
                      freeSolo
                      clearIcon={
                        <CloseIcon onClick={handleAutocompleteClose} />
                      }
                      id="txtsearch"
                      className="searchinput"
                      PopperComponent={StyledPopper}
                      options={useOptions()}
                      groupBy={(option) => option.category}
                      getOptionLabel={(option) =>
                        option.label === undefined ? inputValue : option.label
                      }
                      filterSelectedOptions
                      renderOption={(props, option, { inputValue }) => (
                        <Box component="li" {...props}>
                          {highlightText(option.label, inputValue)}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <ThemeProvider theme={theme}>
                          <TextField
                            {...params}
                            ref={inputRef}
                            inputProps={{
                              ...params.inputProps,
                              "aria-label": t("searchByName"),
                            }}
                            onKeyDown={handleKeyDown}
                            color="success"
                            size="small"
                            variant="outlined"
                            name="txtsearch"
                            id="txtsearch"
                            placeholder={t("searchByName")}
                            value={textSearchValue}
                            data-testid="txt-search"
                            onChange={handleTextSearchChange}
                          />
                        </ThemeProvider>
                      )}
                      onChange={handleAutocompleteInputChange}
                      renderGroup={(params) => (
                        <>
                          <li
                            style={{
                              display: params.key == 0 ? "block" : "none",
                              marginLeft: "3%",
                            }}
                          >
                            Select one or enter 4 or more characters for more
                            options
                          </li>
                          <li key={params.key}>
                            <strong style={{ marginLeft: "3%" }}>
                              {params.group}
                            </strong>
                            <span>{params.children}</span>
                          </li>
                        </>
                      )}
                    />
                    {error && (
                      <div className="error-bubble">
                        <div>
                          <CancelIcon className="error-icon" />
                        </div>
                        {errorMessage}
                      </div>
                    )}
                  </div>
                </Box>

                <Box className="belowTextresp">
                  <div
                    dangerouslySetInnerHTML={{ __html: sanitizedhasBelowText }}
                  ></div>
                </Box>

                <Box className="cityFlex">
                  {/* <div className="nearText">&nbsp;&nbsp;{t('near')}&nbsp;&nbsp;</div> */}
                  <div></div>
                  <div>
                    <AddressLookup
                      errorZip={errorZip}
                      errorMessageZip={errorMessageZip}
                    />
                  </div>
                </Box>

                <div className="searchChangeLinkResp">
                  {(selSiteg?.landingPageindicator !== "N" && !redirectGenericSite) && (
                    <Box pt={2}>
                      <Typography
                        data-testid="change-link"
                        className="change-link"
                        onClick={changeLinkClick}
                      >
                        {t("changeNetwork")}
                      </Typography>
                      <Box>
                        <FormControlLabel
                          className="font16"
                          textAlign={"left"}
                          data-testid="remember-my-network"
                          control={
                            <Checkbox
                              checked={isChecked}
                              data-testid="remember-my-network"
                              onChange={handleChange}
                              color="success"
                              size="small"
                            />
                          }
                          label={t("rememberMyNetwork")}
                        />
                      </Box>
                    </Box>
                  )}
                </div>
              </Box>

              <Box className="change-box">
                <div className="webOnly">
                  {selSiteprop?.siteName && selSiteprop?.redirect  != "Y"  && (
                    <Box className="custSearchWeb">
                      <Box sx={{ mb: 3 }}>{t("customizedfor")}</Box>
                      <Box sx={{ mb: 3 }}>
                        <img
                          src={clientImage}
                          alt={selSiteprop.siteName}
                          // className="search-image-style"
                        />
                      </Box>
                    </Box>
                  )}

                  {(selSiteg?.landingPageindicator !== "N" && !redirectGenericSite) && (
                    <Box ml={7}>
                      <Typography
                        data-testid="change-link"
                        className="change-link"
                        onClick={changeLinkClick}
                      >
                        {t("changeNetwork")}
                      </Typography>
                      <Box >
                        <FormControlLabel
                          className="font16"
                          textAlign={"left"}
                          data-testid="remember-my-network"
                          control={
                            <Checkbox
                              checked={isChecked}
                              data-testid="remember-my-network"
                              onChange={handleChange}
                              color="success"
                              size="small"
                            />
                          }
                          label={t("rememberMyNetwork")}
                        />
                      </Box>
                    </Box>
                  )}
                </div>

                <Box className="belowText">
                  <div
                    dangerouslySetInnerHTML={{ __html: sanitizedhasBelowText }}
                  ></div>
                </Box>

                <Box mt="10px" className="button-box">
                  <Button
                    variant="contained"
                    data-testid="search"
                    color="primary"
                    sx={{
                      textTransform: "initial",
                      borderRadius: "0px !important",
                    }}
                    onClick={handleSearchResults}
                    className="search-btn font16"
                  >
                    {t("search")}&nbsp;
                    <ArrowForwardIosOutlined fontSize="14pt" />
                  </Button>
                </Box>
              </Box>
            </Box>
          </Container>
        )}

        {showSearchResult && <SearchViewResults />}
      </Box>
    </Container>
  );
};

SearchView.propTypes = {
  networkDataprop: PropTypes.any,
  errorprop: PropTypes.any,
  selSiteprop: PropTypes.any,
};

export default SearchView;
